// extracted by mini-css-extract-plugin
export default {"students-list-modal--group-by-class-year__student-item__name":"styles_students-list-modal--group-by-class-year__student-item__name__FL9d0"};